import React from 'react'
import './AppHeader.scss'
import { ReactComponent as Logo } from '../../static/icons/atau.svg'
import UserMenu from './UserMenu'
import { useNavigate } from 'react-router-dom'
import AppHeaderButton from './AppHeaderButton'
import { observer } from 'mobx-react-lite'
import RootStore from '../../store/RootStore'
import { userFioToString } from '../../helpers/userFioToString'
import UserSelect from './UserSelect'
type Props = {}

const AppHeader = observer((props: Props) => {
  const user = RootStore.authStore.user
  const kiosk = RootStore.settingsStore.kiosk
  const navigate = useNavigate()
  const pages = [
    { title: 'Оборудование', path: '/home' },
    { title: 'Заявки', path: '/issue' },
    { title: 'Заказы', path: '/orders/123' }, // Alarme!
    { title: 'Отчет', path: '/reports' },
    { title: 'Админ панель', path: '/admin', isAdmin: true },
  ]

  if (kiosk === 'full') {
    return <div className="App-header-kiosk"></div>
  }

  function refreshPage() {
    window.location.reload();
  }

  return (
    <div className="App-header">
      <div className="App-header-content">
        <div className="App-header-buttons">
          <div className="App-header-logo">
            <button
              onClick={() => {
                navigate('/home')
                refreshPage()
              }}
            >
              <Logo className="logo" fill="white" stroke="white" />
            </button>
          </div>
          {!kiosk
            ? pages.map((obj) => {
                return (
                  <AppHeaderButton
                    key={obj.path}
                    path={obj.path}
                    title={obj.title}
                    isAdmin={obj.isAdmin}
                  />
                )
              })
            : null}
        </div>
        <div className="App-header-userName">
          { user ? userFioToString(user) : <UserSelect /> }
        </div>
        <div className="App-header-icons">
          <UserMenu />
        </div>
      </div>
    </div>
  )
})

export default AppHeader
